import React from "react"
import { Button } from "reactstrap"

const SelectToggleButton = ({ ids = [], selectedIds = [], onToggle }) => {
  const allSelected = ids.every(id => selectedIds.includes(id))

  const handleClick = () => {
    onToggle(ids)
  }

  return (
    <Button
      color={allSelected ? "danger" : "primary"} // primary for select, danger for deselect
      size="sm"
      type="button"
      className="d-flex align-items-center btn-label"
      onClick={handleClick}
    >
      <i
        className={`bx ${allSelected ? "bx-x-circle" : "bx-checkbox"} label-icon`}
      />{" "}
      {allSelected ? "Deselect All" : "Select All"}
    </Button>
  )
}

export default SelectToggleButton
